export default __webpack_public_path__ + "static/media/pdf-image.21840113.jpg";